/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TunneledMcpConnection,
  TunneledMcpConnection$inboundSchema,
} from "./tunneledmcpconnection.js";

/**
 * Live connection details for a tunneled MCP server
 */
export type TunneledMcpServerConnections = {
  /**
   * Number of active tunnel connections currently visible in Redis
   */
  activeConnectionCount: number;
  /**
   * Total MCP consumer sessions currently pinned across active tunnel connections
   */
  activeConsumerSessionCount: number;
  /**
   * available or unavailable: whether live connection storage could be read
   */
  collectionState?: string | undefined;
  /**
   * Live tunnel connections currently visible in Redis
   */
  connections: Array<TunneledMcpConnection>;
  /**
   * Server time when this view was read
   */
  observedAt?: Date | undefined;
};

/** @internal */
export const TunneledMcpServerConnections$inboundSchema: z.ZodMiniType<
  TunneledMcpServerConnections,
  unknown
> = z.pipe(
  z.object({
    active_connection_count: z.int(),
    active_consumer_session_count: z.int(),
    collection_state: z.optional(z.string()),
    connections: z.array(TunneledMcpConnection$inboundSchema),
    observed_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "active_connection_count": "activeConnectionCount",
      "active_consumer_session_count": "activeConsumerSessionCount",
      "collection_state": "collectionState",
      "observed_at": "observedAt",
    });
  }),
);

export function tunneledMcpServerConnectionsFromJSON(
  jsonString: string,
): SafeParseResult<TunneledMcpServerConnections, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TunneledMcpServerConnections$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TunneledMcpServerConnections' from JSON`,
  );
}
